import * as actions from './actions';
import * as getters from './getters';
import { state, mutations } from './mutations';

export default {
  actions,
  getters,
  state,
  mutations,
};